import { z } from 'zod';
export const MessageTranslationDTO = z.object({
    messageId: z.guid(),
    targetLang: z.string(),
    translatedText: z.string(),
    cached: z.boolean(),
});
/**
 * Canonical ISO 639-1 two-letter lowercase language code pattern (e.g. 'ru',
 * 'en'). This is the SINGLE source of truth for validating a `targetLang`
 * everywhere it is checked — the POST request boundary AND the GET read
 * boundaries (per-conversation batch + per-message). Cast-only response DTOs
 * stay loose (plain z.string()) on purpose; they are type sources, not
 * validators.
 */
export const LANG_CODE_RE = /^[a-z]{2}$/;
/**
 * Reusable schema wrapping {@link LANG_CODE_RE} for validating a target
 * language code at any port boundary.
 */
export const LangCode = z.string().regex(LANG_CODE_RE);
/**
 * Target language as an ISO 639-1 two-letter lowercase code (e.g. 'ru', 'en').
 * Validated with a strict regex at the request boundary — unsupported or
 * malformed codes are rejected before reaching the LLM layer.
 * Defaults to 'ru' (the primary WIT LAB audience language).
 */
export const TranslateMessageRequest = z.object({
    targetLang: LangCode.default('ru'),
});
/**
 * Batch response: all cached translations for a conversation at a given
 * targetLang. Used by the thread UI to seed the per-message translation map
 * in a single round-trip instead of N individual GETs.
 */
export const ConversationTranslationItemDTO = z.object({
    messageId: z.guid(),
    targetLang: z.string(),
    translatedText: z.string(),
});
export const ConversationTranslationsDTO = z.object({
    items: z.array(ConversationTranslationItemDTO),
});
//# sourceMappingURL=translations.js.map